var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOldestPasswordCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "smd7tq4eva",
    d: "M0 0h19.167v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.61)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2sa83199sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#smd7tq4eva"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.703 11.11a2.13 2.13 0 0 0-1.856-2.113 2.122 2.122 0 0 0-2.325 1.58 2.13 2.13 0 0 0 1.275 2.508v2.155a.78.78 0 1 0 1.558 0v-2.155a2.125 2.125 0 0 0 1.348-1.975zm7.444-3.76-1.622 10.915A2.052 2.052 0 0 1 15.508 20H3.665a2.047 2.047 0 0 1-2.017-1.735L.025 7.35C-.206 5.854 1.195 4.788 2.602 5h12.98c.324.003 1.214-.002 1.533 0a2.073 2.073 0 0 1 2.032 2.35zM16.581 4H2.601V2.045A2.049 2.049 0 0 1 4.638 0h.92a2.038 2.038 0 0 1 2.036 2h6.95a2.043 2.043 0 0 1 2.037 2z",
    fill: "#AEB3B7",
    mask: "url(#2sa83199sb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldestPasswordCs);
export default __webpack_public_path__ + "static/media/oldest-password-cs.67c70fd7.svg";
export { ForwardRef as ReactComponent };